export default {"src":"/_next/static/media/Primary-CTA_Large.2ffd9a7d.svg","height":52,"width":280,"blurWidth":0,"blurHeight":0};